
//Canaux de diffusion d’une notification (API Ammon Notification)
export const ValCanauxNotification =
{
  Email: "EMAIL",
  Teams: "TEAMS"
} as const;

//Canal de diffusion d’une notification
export type ValCanalNotification = typeof ValCanauxNotification[keyof typeof ValCanauxNotification];

//Représente un type d’événement auquel l’utilisateur peut s’abonner
export class ValTypeEvenementNotification
{
  //Code du type d’événement (ex : EFACT_FACTURES_ACHAT_RECUES)
  public code!: string;

  //Libellé
  public libelle!: string;
}

//Représente un abonnement de l’utilisateur à un type d’événement, sur un canal.
//L’URL de workflow Teams n’est jamais rendue par l’API : seul destinationConfiguree le dit
export class ValAbonnementNotification
{
  //Identifiant (GUID)
  public id!: string;

  //Code du type d’événement
  public codeTypeEvenement!: string;

  //Canal
  public canal!: ValCanalNotification;

  //Indique si la destination (URL Teams) est enregistrée
  public destinationConfiguree!: boolean;
}

//Représente les abonnements de l’utilisateur courant (GET v1.0/abonnement)
export class ValAbonnementsUtilisateur
{
  //Adresse e-mail du compte, null si le compte n’en a pas
  public adresseEmail!: string | null;

  //Types d’événement autorisés pour l’utilisateur
  public typesEvenement!: ValTypeEvenementNotification[];

  //Abonnements de l’utilisateur
  public abonnements!: ValAbonnementNotification[];
}

//Représente le résultat de l’envoi d’un message de test (POST v1.0/abonnement/test)
export class ValTesterCanalNotificationResultat
{
  //Indique si le message a été envoyé
  public succes!: boolean;

  //Erreur rencontrée, null en cas de succès
  public erreur!: string | null;
}
